import Bugsnag from '@bugsnag/js';

const idKey = '_linkedin_partner_id';
const idsKey = '_linkedin_data_partner_ids';

export const runLinkedInCampaigns = () => {
  if (process.env.REACT_APP_ENV !== 'production') return;

  try {
    window[idKey] = '2549977';
    window[idsKey] = window[idsKey] || [];

    if (!window[idsKey].includes(window[idKey])) window[idsKey].push(window[idKey]);
    if (!window.lintrk) {
      window.lintrk = function lintrk(a, b) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];

      const s = document.getElementsByTagName('script')[0];
      const b = document.createElement('script');

      b.type = 'text/javascript';
      b.async = true;
      b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      s.parentNode.insertBefore(b, s);
    }
  } catch (error) {
    Bugsnag.notify(new Error(JSON.stringify({ from: 'runLinkedInCampaigns function', error })));
  }
};
